import { Divider, Typography } from '@material-ui/core';
import React from 'react';
import Button from '../Button';
import { Box, Flex } from '../Layouts';
import { LargeText, Text, Spacer } from '../Typography';
import NotificationItem from '../Notification';

const NotificationCard = ({ notifications, onReadAll }) => {
  const [notfcnId, setActiveNotification] = React.useState(null);

  return (
    <Box>
      <Flex alignItems={'center'}>
        <Typography style={{ fontSize: '18px', fontWeight: 'bold' }}>Notifications</Typography>
        <Spacer />
        <Button
          variant={'text'}
          style={{ cursor: 'pointer' }}
          disabled={notifications?.length < 1}
          color="primary"
          onClick={() => onReadAll()}
        >
          Mark All as Read
        </Button>
      </Flex>
      <Divider />
      <Box style={{ height: '30rem', overflow: 'scroll' }}>
        {notifications && notifications.length > 0 ? (
          notifications.map((notification) => (
            <>
              <NotificationItem
                key={notification.id}
                title={notification.title}
                body={notification.body}
                isRead={notification.isRead}
                onNotificationClick={() => {
                  setActiveNotification(notfcnId ? null : notification.id);
                }}
                reading={notification.id === notfcnId}
              />
              <Divider />
            </>
          ))
        ) : (
          <Text style={{ textAlign: 'center', marginTop: 10 }}>No new notifications!</Text>
        )}
      </Box>
    </Box>
  );
};

export default NotificationCard;
